export default {
  default: () => import("/app/apps/explorer/layouts/default.vue").then(m => m.default || m),
  transaction: () => import("/app/apps/explorer/layouts/transaction.vue").then(m => m.default || m)
}